<template>
  <div class="fx-col">
    <div class="flex-row logo y-center">
      <img src="/images/logo.png" class="top_logo h-full" />
    </div>
    <div class="fx_1 left-menu">
      <Menu theme="dark" :active-name="active" :open-names="openNames" width="100%" accordion @on-select="selectMenu">
        <template v-for="(menu,index) in menus">
          <template v-if="!menu.children">
            <MenuItem :name="index" v-if="menu.name=='影像数据中心'">
              <Icon style="font-size:18px" :type="menu.icon" />
              &nbsp;{{menu.name}}
            </MenuItem>
            <MenuItem :name="index" :to="'/'+menu.path" v-else>
              <Icon style="font-size:18px" :type="menu.icon" />
              &nbsp;{{menu.name}}
            </MenuItem>
          </template>
  
          <Submenu :name="index" v-else>
            <template slot="title">
              <Icon style="font-size:18px" :type="menu.icon" />
              {{menu.name}}
            </template>
            <MenuItem
              :name="index+'-'+index2"
              :to="'/'+menu.path+'/'+ menu2.path"
              v-for="(menu2,index2) in menu.children"
              v-if="menu2.menu"
            >
              <div v-if="selectedItem==index+'-'+index2" class="round_block"></div>
              <Icon class="round_block_icon" type="md-radio-button-off" v-else/>
              {{menu2.name}}
            </MenuItem>
          </Submenu>
        </template>
      </Menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "layoutSidebar",
  data: function () {
    return {
      menus: [],
      active: "/",
      openNames: [],
      selectedItem:''
    };
  },
  created: function () {
    this.createMenu();
    this.init();
  },
  methods: {
    selectMenu(name){
      if(this.menus[name]&&this.menus[name].name=='影像数据中心'){
        this.$api.get('/user/RedirectToImageCenter').then(rsp=>{
          if (rsp != false) {
            window.open(`${TheImageCenterUrl}/#/?${unescape(rsp.data)}`)
          }
        })
      }
      this.selectedItem=name
    },
    init: function () {
      var currentPath = this.$route.path;
      var openName = currentPath.substr(
        0,
        currentPath.split("/")[1].length + 1
      );
      this.openNames = [openName];
      this.active = currentPath;
    },
    createMenu: function () {
      
      //this.menus = this.$router.options.routes[0].children;
      const routes = this.$router.options.routes[0].children;
      let temp_routes = JSON.parse(JSON.stringify(routes));
      let permissionAll = JSON.parse(this.$store.state.permission);
      let permissionMenu = permissionAll.filter((p) => p.privilegeType == "0");
      let userPages = [];
      for (let menu of permissionMenu) {
        userPages.push(menu.privilegeCode);
      }
      //根据用户权限返回菜单
      for (let i = 0; i < temp_routes.length; i++) {
        if (temp_routes[i].children == null) {
          continue;
        }
        for (let j = 0; j < temp_routes[i].children.length; j++) {
          if (
            !userPages.includes(temp_routes[i].children[j].meta.permissionCode)
          ) {
            temp_routes[i].children.splice(j, 1);
            j--;
          }
        }
      }
      let result_routes = temp_routes.filter((p) => p.children==null||p.children.length>0);
      this.menus = result_routes;
    },
  },
};
</script>
<style>
.left-menu::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.left-menu{
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.ivu-menu-item{
  display: flex;
  flex-direction: row;
  align-items: center;
  
}
.ivu-menu-item .round_block{
  margin:0 18px 0 1px;
}
.round_block{
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
}
.ivu-menu-item .round_block_icon{
  margin-right: 16px;
  font-size: 12px;
}
.logo {
  color: #ffffff;
  margin-bottom: 10px;
  border-bottom: 1px solid #3b3d40;
  padding: 3px 0;
  background-color: white;
  border-right: 1px solid #ccc;
}
.top_logo{
  width: 12rem;
  height: 42px;
  margin: auto;
}
.fs18 {
  font-size: 18px;
}
</style>